export default (state = {}, action) => {
  switch (action.type) {
    case 'ACTION_TYPE':
      return;
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/pages/index.js